import { Outlet } from 'react-router-dom'

import { Box, Button, GridBoxList } from '@factorialco/deprecated-design-system'
import { DetailsRootPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'

import DeleteCompanyAction from 'modules/billing/components/DeleteCompanyAction'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import BankAccountsBlock from 'modules/settings/components/BankAccountsBlock'
import FormatsBlock from 'modules/settings/components/FormatsBlock'
import GeneralBlock from 'modules/settings/components/GeneralBlock'
import PreviewLegalEntity from 'modules/settings/components/Payroll/LegalEntities/_PreviewLegalEntity'
import CollectionsBootstrap from 'modules/settings/lib/DetailsCollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading, error } = useQuery(DetailsRootPageDocument, {
    variables: { companyId: companyId },
  })
  const company: Company = companies.current

  const legalEntities = data?.apiCore.currentsConnection.nodes[0]?.company.legalEntities ?? []
  const inFreeTrial = data?.apiCore.currentsConnection.nodes[0]?.company.subscription.inFreeTrial
  const hasNewPayroll = data?.features.featuresConnection.nodes[0]?.enabled

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="narrow"
      widget={
        <Button.Router iconName="add" to={navigation.settings.details.newLegalEntity.fullPath()}>
          {i18n.t('settings.legal_entities.add')}
        </Button.Router>
      }
      header={{
        title: i18n.t('settings.legal_entities.title'),
        description: i18n.t('settings.legal_entities.description'),
      }}
    >
      <Box paddingBottom="s24">
        <GridBoxList centered={legalEntities.length < 2}>
          {legalEntities.map((legalEntity) => (
            <PreviewLegalEntity
              key={legalEntity.id}
              legalEntityId={legalEntity.id}
              legalEntitiesCount={legalEntities.length}
              extra={{
                'data-intercom-target': legalEntity.main
                  ? 'settings-main-legal-entity'
                  : 'settings-legal-entity-list-item',
              }}
            />
          ))}
        </GridBoxList>
      </Box>
      <GeneralBlock company={company} />
      <FormatsBlock company={company} />
      {hasNewPayroll && <BankAccountsBlock />}
      {/* <SAMLBlock /> */}
      {inFreeTrial && <DeleteCompanyAction />}
      <Outlet />
    </ResponsivePage.Body>
  )
}

const DetailsRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default DetailsRootPage
